module.exports = function(TomSelect, Modal) {

	const newCustomerDaySelect = new TomSelect("#new-day-picker", {
		// allowEmptyOption: true
		onChange: newCustomerDateSelectHandler,
		render: {
			no_results: function(data, escape) {
				return "<div class='no-results'>" + escape(this.input.dataset.noRecords) + "</div>";
			}
		}
	});

	const newCustomerMonthSelect = new TomSelect("#new-month-picker", {
		// allowEmptyOption: true
		onChange: newCustomerDateSelectHandler,
		render: {
			no_results: function(data, escape) {
				return "<div class='no-results'>" + escape(this.input.dataset.noRecords) + "</div>";
			}
		}
	});

	const newCustomerYearSelect = new TomSelect("#new-year-picker", {
		// allowEmptyOption: true,
		maxOptions: 200,
		onChange: newCustomerDateSelectHandler,
		render: {
			no_results: function(data, escape) {
				return "<div class='no-results'>" + escape(this.input.dataset.noRecords) + "</div>";
			}
		}
	});

	new TomSelect("#new-country-code", {
		// allowEmptyOption: true,
		maxOptions: 200,
		render: {
			no_results: function(data, escape) {
				return "<div class='no-results'>" + escape(this.input.dataset.noRecords) + "</div>";
			}
		}
	});

	new TomSelect("#new-citizenship", {
		// allowEmptyOption: true,
		maxOptions: 200,
		render: {
			no_results: function(data, escape) {
				return "<div class='no-results'>" + escape(this.input.dataset.noRecords) + "</div>";
			}
		}
	});

	function newCustomerDateSelectHandler() {

		const date = `${newCustomerYearSelect.getValue()}-${newCustomerMonthSelect.getValue()}-${newCustomerDaySelect.getValue()}`;
		document.getElementById("new-birthday-input").value = date;
	}

	const mobileInput = document.getElementById("new-mobile-number");
	mobileInput.addEventListener("input", function() {

		this.value = this.value.replace(/[^0-9]/g, "");
	});

	const homePhoneInput = document.getElementById("new-home-phone");
	homePhoneInput.addEventListener("input", function() {

		this.value = this.value.replace(/[^0-9]/g, "");
	});

	const emailInput = document.getElementById("new-email-input");
	emailInput.addEventListener("blur", function() {

		const loadingCnt = document.getElementById("loading-new-email-verification");
		const errorCnt = document.getElementById("invalid-email");

		if ( this.value.trim().length < 10 ) {

			return false;
		}

		errorCnt.classList.add("hidden");
		loadingCnt.classList.remove("hidden");

		axios.post("/verify-email", {
			email: this.value
		})
		.then( res => {

			const {ReasonCode, ClientMessage} = res.data;

			if ( ReasonCode != 0 ) {

				loadingCnt.classList.add("hidden");
				errorCnt.textContent = ClientMessage;
				errorCnt.classList.remove("hidden");
			}
		})
		.catch(err => console.log(err))
		.then(() => {

			loadingCnt.classList.add("hidden");
		})
	});
}
